import React from 'react';
import { Link } from 'react-router-dom';
import { IconZap, IconDatabase } from './SVGIcons';

type CreditMeterPackType = 'credits' | 'database';

interface CreditMeterButtonProps {
  /**
   * Which pool this page's credit usage belongs to -- only used to pick the
   * icon ('credits' is the unified pool that workflows and analyzers share;
   * Database gets a database icon). Both link to the Assign tab's credits
   * overview.
   */
  packType: CreditMeterPackType;
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * "Track Credits" header button -- takes the user to the credits usage
 * overview on the Profile page's Assign tab. Same visual treatment everywhere it's used (ACE/Tariff/AES Analyzer, Entity Hub, Product DB, Export Hub, Import/
 * Export Workflow, Beneficial Ownership).
 */
const CreditMeterButton: React.FC<CreditMeterButtonProps> = ({
  packType,
  size = 'md',
  className = '',
}: CreditMeterButtonProps) => {
  const Icon = packType === 'database' ? IconDatabase : IconZap;

  return (
    <Link
      to={{
        pathname: '/profile',
        hash: '#credits-section',
        state: {
          // The usage overview + #credits-section scroll target live on the
          // Assign tab; the Subscriptions tab has no credits section.
          linkTab: 'Assign',
        },
      }}
      className={`cmb-btn cmb-${size} ${className}`.trim()}
    >
      <Icon />
      <span>Track Credits</span>
    </Link>
  );
};

export default CreditMeterButton;
